import { render, staticRenderFns } from "./compBindLightVehicle.vue?vue&type=template&id=65107ea6"
import script from "./compBindLightVehicle.vue?vue&type=script&lang=js"
export * from "./compBindLightVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports